// map dependencies
let maplibregl = require("maplibre-gl");
let debounce = require("./lib/debounce");

var d3 = {
  ...require("d3-selection"),
  ...require("d3-scale"),
  ...require("d3-scale-chromatic"),
  ...require("d3-array")
};

var turf = {
  ...require('@turf/bbox'),
  ...require('@turf/bbox-polygon'),
  ...require('@turf/boolean-intersects'),
  ...require('@turf/helpers')
}

var noUiSlider = require("nouislider");
let dateSlider;
let labelsToggle;

// map parameters
let mapParams = require("./map-params.js");

let controls = d3.select('div.custom-controls');
let layersPanel = controls.select('div.layers');
let layers;
let checkboxes;
let sliders;
let hoveredStateId = null;

let labelsAreAbove = null;

let updating = false;

let beforeOpacityChange = 1;
let ready = false;

// for loading pmtiles
import { Protocol } from "pmtiles";
let protocol = new Protocol();
maplibregl.addProtocol("pmtiles",protocol.tile);

// add COG protocol
// import {cogProtocol, setColorFunction} from '@geomatico/maplibre-cog-protocol';
// maplibregl.addProtocol('cog', cogProtocol);


// pmtiles stored on cloudflare
let pmtilesUrlBase = "https://northwoodshistoricalatlas.org/map-assets/imagery/";

// datasets
let datasets = require("../../data/datasets.sheet.json");
let filtered = datasets.filter(data => data.synced).sort((a,b)=> b.survey_year_end - a.survey_year_end);


let currentlyVisible;
let currentlyIntersecting;
let timeFiltered;
let addedImagery = [];

let map;
let filteredMasks;

// make color scale
let years = filtered.map(s => s.survey_year_end);
let minYear = d3.min(years);
let maxYear = d3.max(years);


let colorScale = d3.scaleSequential()
                    .domain([minYear,maxYear])
                    .interpolator(d3.interpolateViridis)

fetch("https://northwoodshistoricalatlas.org/map-assets/mask/combined-mask.geojson")
      .then(response => response.json())
      .then(function(data){
        // filter to just synced surveys
        data.features = data.features.filter(function(feature){
            let ids = filtered.map(survey => survey["file_name"]); 
            return (ids.indexOf(feature.properties["maskName"]) > -1);
        });
        // set color to use later with maplibre
        data.features.forEach(function(survey){
          let surveyData = filtered.filter(d => d["file_name"] == survey.properties["maskName"])[0];
          survey.properties.year = surveyData["survey_year_end"];
          survey.properties.visible = true;
          if(surveyData["file_name"].includes("MDI")) {
            survey.properties.color = "#333";
          } else {
            survey.properties.color = colorScale(surveyData["survey_year_end"]);
          }
        })


        data.features.sort((a,b) => a.properties.year - b.properties.year);

        filteredMasks = data;

        instantiateMap();
        onMapLoad();

      })


function instantiateMap(){

  map = new maplibregl.Map({
    container: 'map',
    style: mapParams.basemapStyles[0].url,
    bounds: mapParams.startingBounds,
    maxBounds: mapParams.maxBounds,
    // scrollZoom: false,
    maplibreLogo: false,
    attributionControl: {compact: false}
  });


  // Add zoom controls to the map.
  map.addControl(new maplibregl.NavigationControl({
      showZoom: true,
      showCompass: false
  }));

  // setup label ordering listener
  labelsToggle = layersPanel.select("div.refLayer")
                                .select("input");

  labelsToggle.on("change", function(event){
    toggleLabelOrder(event)
  });

  // add layers to panel
  layers = layersPanel.selectAll("div.layer")
            .data(filtered)
            .enter()
            .append("div")
            .attr("class", d => "layer "+ d["file_name"]);

  // checkbox
  checkboxes = layers.append("div")
                  .attr("class", "checkbox")
                  .append("input")
                  .attr("class", d => d["file_name"] + " check")
                  .attr("type", "checkbox")
                  .attr("checked", true);

  checkboxes.on("change", function(event,d){

    console.log(this);
    console.log(this.checked);


    let mask = filteredMasks.features.find(m => m.properties["maskName"] == d["file_name"]);
    let slider = layers.select(`input.slider.${d["file_name"]}`)
          .node();

    if(this.checked){
        
          slider.value = 1;
      
       
       beforeOpacityChange = 1;

      if(mask) {
        mask.properties.visible = true;
      }
     
      map.getSource('surveys').setData(filteredMasks);
      // update visible and add imagery if necessary
      updateVisible();
      addImagery();


      if(map.getLayer(d["file_name"])){
        map.setPaintProperty(d["file_name"],"raster-opacity",1);
      } 

    } else {
      // set slider to 0 (also triggers raster opacity update)
      slider.value = 0;
      beforeOpacityChange = 0;


        if(mask){
          mask.properties.visible = false;
        }
        

      // update visible and add imagery if necessary
      updateVisible();

      map.getSource('surveys').setData(filteredMasks);

      if(map.getLayer(d["file_name"])){
        map.setPaintProperty(d["file_name"],"raster-opacity",0);
      } 
    }

  });

  // toggle all functionality
  controls.select("span.toggle-all").on("click", function(){
    // toggle all checkboxes on
    checkboxes.each(function(d){ 

        if(!this.checked){
            this.checked = true;
            d3.select(this).dispatch("change"); 
        }
    });

    // also reset date slider
    dateSlider.noUiSlider.set([minYear,maxYear]);
  });

  // zoom out functionality
  controls.select("span.zoom-out").on("click", function(){
    // zoom map to starting bounds
    let bbox = mapParams.startingBounds;

    map.fitBounds([
        [bbox[0], bbox[1]], // southwestern corner [lng, lat]
        [bbox[2], bbox[3]]  // northeastern corner [lng, lat]
    ]);

  });

  // swatch
  let layerSwatches = layers.append("div")
            .attr("class", "color-swatch")
            .style("background-color", d => d["file_name"].includes("MDI") ? "#333" : colorScale(d["survey_year_end"]));

  // highlighting
  layerSwatches.on("mouseover", (event,d) => highlightLayer(event,d["file_name"]));
  layerSwatches.on("mouseout", (event,d) => unhighlightLayer(event,d["file_name"]));

  // clicking
  layerSwatches.on("click", (event,d) => focusLayer(event,d["file_name"]));

  // title          
  let layerNames = layers.append("div")
            .attr("class", "layer-name")
            .text(d => `${d["name"]} ${d["survey_year"]}`);
  // highlighting
  layerNames.on("mouseover", (event,d) => highlightLayer(event,d["file_name"]));
  layerNames.on("mouseout", (event,d) => unhighlightLayer(event,d["file_name"]));

  // clicking
  layerNames.on("click", (event,d) => focusLayer(event,d["file_name"]));

  // metadata button
  layers.append("div")
            .attr("class", "metadata-button")
            .text("i")
            .attr("title", "See survey metadata")
            .on("click", function(event,d){
                let button = d3.select(this);
                // update appearance
                button.classed("visible", !button.classed("visible"));

                // toggle visibility of metadata
                let metadata = layersPanel.select(`div.layer-metadata.${d["file_name"]}`);
                metadata.classed("visible", !metadata.classed("visible"));


            })

  // opacity slider
  sliders = layers.append("div")
            .attr("class", "opacity-slider")
            .append("input")
            .attr("class", d => d["file_name"] + " slider")
            .attr("type", "range")
            .attr("min",0)
            .attr("max",1)
            .attr("step",0.01);

  // add event listener for slider
  sliders.on("input", function(event,d){

    const value = +this.value; // Get current value

    // update checkbox
    let checkbox = layers.select(`input.check.${d["file_name"]}`);
          
    // if 0 uncheck checkbox
    if(value == 0){
      checkbox.node().checked = false;
      // and trigger change
      checkbox.dispatch("change");

    }
    // or if it was 0 before and is greater check
     if(value > 0){
      checkbox.node().checked = true;
      // and trigger change
      if(beforeOpacityChange == 0 ){
        checkbox.dispatch("change",{"fromSlider":true});
      }

      
     }

    // update raster opacity
    // check for layer first
    if(map.getLayer(d["file_name"])){
      map.setPaintProperty(d["file_name"],"raster-opacity",value);
    }
    beforeOpacityChange = value;
   
  });

  // filter by date
  dateSlider = document.getElementById('date-slider');

  // build slider
  noUiSlider.create(dateSlider, {
      start: [+minYear,+maxYear],
      step: 1,
      // snap: true,
      connect: true,
      range: {
          'min': +minYear,
          'max': +maxYear
      },
      pips: {
        mode: 'values',
        values: [+minYear,1950,1960,1970,+maxYear],
        density: 3,
        stepped: true
      }
  });

  // start with full range
  timeFiltered = filtered.map( s => s["file_name"]);

  // metadata
  layers.append("div")
            .attr("class", d => `layer-metadata ${d["file_name"]}`)
            .html(d => `<p>Survey dates: ${d["survey_date"]}</p>
                        <p>Client: ${d["client"]}</p>
                        <p>Collection: ${d["collection"]}</p>
                        <p>Number of photos: ${d["number_photos"]}</p>
                        <p>Photo overlap: ${d["photo_overlap"]}</p>
                        <p>Spatial resolution: ${d["spatial_resolution"]} meters</p>
                        `)
      
}

function insertInOrder(existingArray,additional){
    let newArray = existingArray;
    let years = existingArray.map(e => e.replace(/\D/g, ""));
    let insertionPoint = years.findLastIndex(y => y >= additional.replace(/\D/g, ""))+1;
    newArray.splice(insertionPoint,0,additional);
    return newArray;
}

function updateVisible(){

  const bounds = map.getBounds().toArray();
  const bbox = [bounds[0][0],bounds[0][1],bounds[1][0],bounds[1][1]];
  const bboxPoly = turf.bboxPolygon(bbox);


  let intersectingMasks = filteredMasks.features.filter(feature => {
    return turf.booleanIntersects(feature, bboxPoly);
  });
  if(ready){
    intersectingMasks = intersectingMasks.filter(survey => timeFiltered.indexOf(survey.properties["maskName"]) > -1);
  }

  let intersectingSurveys = intersectingMasks.map(feature => feature.properties.maskName);

  let visibleMasks = intersectingMasks.filter(f => f.properties.visible == true);
  let visibleSurveys = visibleMasks.map(feature => feature.properties.maskName);

  currentlyVisible = visibleSurveys;
  currentlyIntersecting = intersectingSurveys;

  updateLayersPanel();

}


function updateLayersPanel(){

  if(!ready) return;
  
  const currentZoom = map.getZoom();

  layers.classed("hidden", d => currentlyIntersecting.indexOf(d["file_name"]) == -1);

  layers.classed("imagery-visible", d => (currentlyIntersecting.indexOf(d["file_name"]) > -1 && currentZoom >= 9.5));

  layers.classed("filtered", d => timeFiltered.indexOf(d["file_name"]) == -1 );

}

// keep imagery layer order right
function findLayerIndex(survey) {
  addedImagery = insertInOrder(addedImagery,survey);
  // get index of current layer
  let i = addedImagery.indexOf(survey);
  // check if there's something newer
  if(i > 0){
    // return layer id of closest newer survey
    return addedImagery[i-1];
  } else if (labelsAreAbove != null) {
    // return layer id of lowest layer with "layers" in ID 
    return labelsAreAbove;
  }
  else {
    // add on top of drawing order
    return null;
  }


}


function addImagery(){

  // get current zoom level
  const currentZoom = map.getZoom();

  // only need to add imagery if we're below 9
  if(currentZoom <= 9.5) {
    return;
  }

  // adjust layers to make opacity slider visible
  updateLayersPanel();

  // add imagery
  currentlyVisible.forEach(survey => {

    // check for source and add
    if (!map.getSource(survey)) {


        // switched back to pmtiles
        map.addSource(survey, {
          type: "raster",
          url: `pmtiles://${pmtilesUrlBase}${survey}.pmtiles`,
        });

        // append to apply color scale
        // #color:BrewerGreys9,253,0,c 


    }

    if (!map.getLayer(survey)) {

        // check slider for raster opacity
        let surveyOpacity = +sliders.filter(d => d["file_name"] == survey).property("value");


        // returns null if it's newest survey, adds on top
        let insertUnder = findLayerIndex(survey);

        map.addLayer(
        {
          id: survey,
          type: "raster",
          source: survey,
          minzoom: 9.5,
          paint: {
            "raster-fade-duration": 1000,
            "raster-opacity": surveyOpacity
          }
        },insertUnder);

        let allLayers = map.getStyle().layers;
        console.log(allLayers);
        // replace below by checking slider value
        // and ssetting paint property accordingly
        // when adding layer

        // console.log(currentlyVisible);
        // // make sure sliders are updated for
        // // currently visible layers
        // sliders.each(function(d){
        //     console.log("here!");

        //     let current = d3.select(this)
        //     current.dispatch("input");

        // });


    }
    
  });

  // remove layers if necessary
  let removeSurveys = addedImagery.filter(survey => currentlyVisible.indexOf(survey) == -1);

  if(removeSurveys.length > 0){
      for(var survey of removeSurveys){
          addedImagery.splice(addedImagery.indexOf(survey),1);
          if(map.getLayer(survey)){
            map.removeLayer(survey);
          }
      }
  }
 

}



function highlightLayer(event,targetId){

  // highlight in map
  if (hoveredStateId) {
      map.setFeatureState(
          {source: 'surveys', id: hoveredStateId},
          {hover: false}
      );
  }
  hoveredStateId = targetId;
  // if(targetId.includes("MDI")){
  //   hoveredStateId = "MDI1979";
  // }

  map.setFeatureState(
      {source: 'surveys', id: hoveredStateId},
      {hover: true}
  );

  // highlight in legend as well
  layersPanel.selectAll(`div.layer`).classed("hovered",false);
  layersPanel.select(`div.layer.${targetId}`).classed("hovered",true);


}

function unhighlightLayer(event,targetId){

  // remove highlighting in legend
  layersPanel.selectAll(`div.layer`).classed("hovered",false);

  // unhighlight features on map
  map.setFeatureState(
      {source: 'surveys', id: targetId},
      {hover: false}
  );
  hoveredStateId = null;

}



// trigger by clicking on layer in legend
// or by clicking on mask in map
function focusLayer(event,targetId){

  console.log(`focus ${targetId}`);

  // turn on this layer and all others off
  checkboxes.each(function(d){
    if(d["file_name"] == targetId){
      this.checked = true;
    } else {
      this.checked = false;
    }
   d3.select(this).dispatch("change");
  });


  // if(targetId.includes("MDI")){
  //   targetId = "MDI1979";
  // }


  // get geojson feature
  let feature = filteredMasks.features.find(mask => mask.properties["maskName"] == targetId);

  if(!feature) return;

  // get features bounds
  const bbox = turf.bbox(feature)

  // zoom to layer
  map.fitBounds([
      [bbox[0], bbox[1]], // southwestern corner [lng, lat]
      [bbox[2], bbox[3]]  // northeastern corner [lng, lat]
  ], {
      padding: 50, // Optional padding in pixels
      maxZoom: 12  // Optional cap on how close to zoom in
  });

  // 

  // if we're zoomed in to imagery level:
  // set imagery opacity to 1
  // set other imagery opacities to 0


}

// handle basemap switching
function activateButtons(){

  const basemapButtons = document.querySelector("div.custom-controls").querySelectorAll("button.basemap");

  basemapButtons.forEach(button => {
      button.addEventListener('click', (event) => {
          // update which button has active class
          // turn off active for all
          basemapButtons.forEach(btn => {
              btn.classList.remove('active');
          });

          // add active to clicked button
          event.target.classList.add('active');

          // reference button that was clicked
          let basemap = event.target.textContent;
          // get URL for this style
          let url = mapParams.basemapStyles.filter(map => map.style == basemap)[0].url;

          // console.log(map.getStyle().layers);
          // // store previous custom layers before changing
          // let overlays = map.getStyle().layers.filter(layer => layer.source == "surveys" || layer.type == "raster");
          // console.log(overlays);

          // // update map style
          map.setStyle(url);
          // // // check what layers are on the map 
          // const allLayers = map.getStyle().layers;
          // console.log(allLayers);

          // re-add overlays
          addMasks();
          addImagery();

          // update label order
          labelsToggle.dispatch("change");

      });
  });

}

function toggleLabelOrder(event){
  if(!ready) return;

  let checked = event.target.checked;
 
  // // get all current layers
  let allLayers = map.getStyle().layers;

  // track if there are raster layers
  rasterLayers = addedImagery;
  let isRaster = rasterLayers.length > 0;

  // get layers with "labels in id"
  let labelLayers = allLayers.filter(l => l["id"].includes("labels"));


  // case: moving labels to top of drawing order
  if(checked){
    for(let layer of labelLayers){
        // store bottom label layer index to place imagery below
        if(labelLayers.indexOf(layer) == 0){
          labelsAreAbove = layer["id"]
        }
        map.moveLayer(layer["id"]);
    }
  }
  // case: moving labels to draw just beneath surveys (but above where they were before)
  else {
    for(let layer of labelLayers){
        let insertUnder = isRaster ? rasterLayers[0] : "surveys-fill";
        map.moveLayer(layer["id"],insertUnder);
    }
    allLayers = map.getStyle().layers;
    // update tracker
    labelsAreAbove = null;
  }



}

function addMasks(){

  if (!map.getSource("surveys")) {
      // add geojson
      map.addSource("surveys", {
          type: "geojson",
          data: filteredMasks,
          promoteId: "maskName"
          // data: "https://pub-b73f484c2fd14f749f91dbdd558a3bdf.r2.dev/north-woods/data/mask/combined-mask.geojson"
      });

  }

  // fill
  if (!map.getLayer("surveys-fill")) {
      
      map.addLayer({
                'id': 'surveys-fill',
                'type': 'fill',
                'source': 'surveys',
                filter: ['!=', ['get', 'visible'], false],
                 maxzoom: 9.5,
                'paint': {
                    'fill-color': ["get", "color"],
                    'fill-opacity': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        0.5,
                        0.25
                    ]
                }
        });
  }

  // stroke
  if (!map.getLayer("surveys-stroke")) {
      
      // stroke
      map.addLayer({
                'id': 'surveys-stroke',
                'type': 'line',
                'source': 'surveys',
                filter: ['!=', ['get', 'visible'], false],
                 maxzoom: 9.5,
                'paint': {
                    'line-color': "#777",
                    'line-opacity': 0.75,
                    'line-width': 0.5
                }
        });
  }
 

}

function onMapLoad(){

  // on map load
  map.on("load", () => {

    // activate basemap switching
    activateButtons();
    });

    // addMasks();

  // if basemap switches reupdate custom layers
  map.on('styledata', function () {
    // add debounce?
    addMasks()
    addImagery();
  });

  updateVisible();

  // add imagery on zoom
  map.on("moveend", function(){
    // update which layers are visible
    updateVisible();
    addImagery();
  });

  // Change the cursor to a pointer above mask layer
   map.on('mouseenter', 'surveys-fill', () => {
      map.getCanvas().style.cursor = 'pointer';
  });

  // add hover highlighting
  map.on('mousemove', 'surveys-fill', (e) => {

          if (e.features.length > 0) {
              if (hoveredStateId) {
                  map.setFeatureState(
                      {source: 'surveys', id: hoveredStateId},
                      {hover: false}
                  );
              }
              hoveredStateId = e.features[0].properties.maskName;
              map.setFeatureState(
                  {source: 'surveys', id: hoveredStateId},
                  {hover: true}
              );
              // highlight in legend as well
              layersPanel.selectAll(`div.layer`).classed("hovered",false);
              layersPanel.select(`div.layer.${hoveredStateId}`).classed("hovered",true);


          }
      });

      // When the mouse leaves the state-fill layer, update the feature state of the
      // previously hovered feature.
      map.on('mouseleave', 'surveys-fill', () => {
          map.getCanvas().style.cursor = '';
          // remove highlighting in legend
          layersPanel.selectAll(`div.layer`).classed("hovered",false);

          if (hoveredStateId) {
              map.setFeatureState(
                  {source: 'surveys', id: hoveredStateId},
                  {hover: false}
              );
          }
          hoveredStateId = null;
      });

      // focus layer interaction
      map.on("click", "surveys-fill", (e) => {
          if (e.features.length > 0) {
            focusLayer(e,e.features[0].properties["maskName"]);
          }    
      });

      function sliderChange(){
        // get start and end
        var start = dateSlider.noUiSlider.get(true)[0];
        var end = dateSlider.noUiSlider.get(true)[1];

        // filter full data set to just those within range
        timeFiltered = filtered.filter(function(survey){
          if(+survey.survey_year_end >= start && +survey.survey_year_end <= end){
            return true;
          } else {
            return false;
          }
        }).map( s => s["file_name"]);

        if(ready = true){
          // update layers panel
          updateLayersPanel();

          // update mask visibility
          filteredMasks.features.forEach(function(mask){
              mask.properties.visible = timeFiltered.indexOf(mask.properties["maskName"]) > -1;
          });

          map.getSource('surveys').setData(filteredMasks);
          updateVisible();

          // add/remove any imagery based on filters
          addImagery();

          // make sure image opacity is in sync with slider
        }
      }

      // event listener for slider
      // event handling
      dateSlider.noUiSlider.on("slide", sliderChange);
      dateSlider.noUiSlider.on("set", sliderChange);       

      ready = true;

}
